import httpDao from "@/infrastructure/httpDao";

export const NOTIFICATION_DOMAINS = [
  {
    domain: "APPLICATIONS",
    label: "体験・入会・受講申請",
    description: "体験申し込み、入会申請、コース追加申請",
  },
  {
    domain: "ATTENDANCE",
    label: "出欠・振替",
    description: "欠席・遅刻の報告、振替申請",
  },
  {
    domain: "EVENTS",
    label: "イベント",
    description: "イベントの申し込み、キャンセル・キャンセル依頼",
  },
  {
    domain: "INQUIRIES",
    label: "お問い合わせ",
    description: "外部から届いたお問い合わせ",
  },
  {
    domain: "CHAT",
    label: "チャット",
    description: "教室対応・個別チャットの新しいメッセージ",
  },
  {
    domain: "PAYMENTS",
    label: "決済・返金",
    description: "確認が必要な返金（請求管理権限のある方のみ）",
  },
  {
    domain: "MEMBERSHIP",
    label: "休会",
    description: "休会期限が近づいたときのお知らせ",
  },
] as const;
export type NotificationDomain =
  (typeof NOTIFICATION_DOMAINS)[number]["domain"];
export type NotificationPreference = {
  domain: NotificationDomain;
  pushEnabled: boolean;
  emailEnabled: boolean;
  inAppEnabled: boolean;
};
export const NOTIFICATION_PREFERENCES_CHANGED =
  "staff-notification-preferences:changed";
export const staffNotificationPreferenceRepository = {
  async get(): Promise<NotificationPreference[]> {
    const response = await httpDao.get<{
      preferences: NotificationPreference[];
    }>("/staff-notification-preferences/me");
    return response.data.preferences;
  },
  async save(
    preferences: NotificationPreference[]
  ): Promise<NotificationPreference[]> {
    const response = await httpDao.patch<{
      preferences: NotificationPreference[];
    }>("/staff-notification-preferences/me", { preferences });
    window.dispatchEvent(new Event(NOTIFICATION_PREFERENCES_CHANGED));
    return response.data.preferences;
  },
};
